import graphql from "babel-plugin-relay/macro";
import { max, min } from "lodash";
import { useFragment } from "react-relay";

import { useDepartmentGolfFacilitiesGroupSize_department$key } from "./__generated__/useDepartmentGolfFacilitiesGroupSize_department.graphql";

export const useDepartmentGolfFacilitiesGroupSize = (
  departmentRef: useDepartmentGolfFacilitiesGroupSize_department$key | null
) => {
  const department = useFragment(
    useDepartmentGolfFacilitiesGroupSizeFragmentString,
    departmentRef
  );

  const golfFacilities = department?.facilities?.edges?.flatMap((e) =>
    e?.node?.type === "GOLF_COURSE" ? [e.node] : []
  );

  const minGroupSizes =
    golfFacilities?.flatMap((facility) => {
      const minGroupSize = facility?.minMaxGroupSize?.min;
      return minGroupSize ? [minGroupSize] : [];
    }) || [];

  const maxGroupSizes =
    golfFacilities?.flatMap((facility) => {
      const maxGroupSize = facility?.minMaxGroupSize?.max;
      return maxGroupSize ? [maxGroupSize] : [];
    }) || [];

  const minGroupSize = min(minGroupSizes) || 1;
  const maxGroupSize = max(maxGroupSizes) || 4;

  return {
    min: minGroupSize,
    max: maxGroupSize,
  };
};

const useDepartmentGolfFacilitiesGroupSizeFragmentString = graphql`
  fragment useDepartmentGolfFacilitiesGroupSize_department on Department {
    facilities {
      edges {
        node {
          type
          minMaxGroupSize(bookingType: STANDARD) {
            min
            max
          }
        }
      }
    }
  }
`;
